import {useUserStore} from './../store/user';
import{WP_API_ROOT, APP_ID} from './../Constants';
import{getQueryParamsFromObject} from './../utils/utils-app';
import{fetchTimeout, handleResult, handleFetchError} from './api-root';


export const createUser = async (user: object)=>{

   const body = {
      app_id: APP_ID,
      ...user
   }

   return fetch(WP_API_ROOT + 'user', { 
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      method: 'POST',
      body: JSON.stringify(body)

   }).then((res) => {
      if (res.ok) return res.json();
      return res.json().then(json => Promise.reject(json));
  });
};


export const validateToken = async (): Promise<{valid: boolean}>=>{

   const body = {
      app_id: APP_ID,
      token:useUserStore.getState().token
   };

   return fetch(WP_API_ROOT + 'user/validate?'+getQueryParamsFromObject(body)).then((res) => {
      if (res.ok){
         const json: {valid: boolean} | any = res.json();
         return json;
      }
      return res.json();
  });
};


export const wpAuthGET = async (route: any, args?: Object): Promise<any>=>{

   const body = {
      app_id: APP_ID,
      ...args,
   }
   const access_token = useUserStore.getState().token;

   const request = fetch(WP_API_ROOT + route + '?' + getQueryParamsFromObject(body), {
      headers: { 
         'Content-Type': 'application/json;charset=UTF-8',
         Authorization:`Bearer ${access_token}`
      },
      referrerPolicy:'origin-when-cross-origin',
      method: 'GET'
   });

   const result: any = await Promise
   .race([fetchTimeout(), request])
   .catch(handleFetchError);

   return handleResult(result);
};



export const wpAuthPOST = async (route: any, args: Object): Promise<Object>=>{

   const body = {
      app_id: APP_ID,
      ...args,
   }
   const access_token = useUserStore.getState().token;

   const request = fetch(WP_API_ROOT + route, {
      headers: { 
         'Content-Type': 'application/json;charset=UTF-8',
         Authorization:`Bearer ${access_token}`
      },
      referrerPolicy:'origin-when-cross-origin',
      method: 'POST',
      body: JSON.stringify(body),
   });

   const result: any = await Promise
   .race([fetchTimeout(), request])
   .catch(handleFetchError);

   return handleResult(result);
};